import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

// Phase 25.16k — Bespoke-page hardening (visual layer).
//
// Single 1-line header strip rendered at the very top of every bespoke
// ABM page (/ventia, /strategic-planning-institute, /iwg). Visually
// signals to ANY visitor — intended recipient or accidental — that the
// page is a one-to-one document, not a public marketing page.
//
// For the intended recipient (Shaun at Ventia, Burditt, Mercedes at
// IWG): reinforces the "this was made specifically for you" feel.
// For an accidental visitor (a competitor stumbling in via direct link
// share): tells them "you weren't supposed to see this." Both of those
// effects are valuable.
//
// Paired with useNoIndex() (Phase 25.16i) for the technical layer, this
// is the visual layer of the same hardening pass.
//
// Usage:
//   <BespokePageRibbon prospectName="Ventia" />
//   <BespokePageRibbon prospectName="Strategic Planning Institute · Burditt Krost" muted />
//
// Props:
//   - prospectName: the intended recipient label (free text)
//   - muted: if true, drops the saturation of the amber tone (use on
//     pages where the existing hero is already very amber-heavy, e.g.
//     /strategic-planning-institute)
export default function BespokePageRibbon({ prospectName, muted = false }) {
  const bg = muted ? "bg-[#1A1409]" : "bg-[#FFB000]";
  const fg = muted ? "text-[#FFB000]" : "text-black";
  const borderC = muted ? "border-b border-[#FFB000]/30" : "border-b border-black/20";

  return (
    <div
      className={`${bg} ${fg} ${borderC} font-mono text-[10px] uppercase tracking-[0.22em] px-4 sm:px-6 py-2.5 flex items-center justify-between flex-wrap gap-2`}
      data-testid="bespoke-page-ribbon"
    >
      <div className="flex items-center gap-2 min-w-0">
        <Lock className="w-3 h-3 flex-shrink-0" />
        <span className="truncate">
          // BESPOKE · PREPARED FOR <b>{prospectName}</b> · NOT FOR PUBLIC DISTRIBUTION
        </span>
      </div>
      <Link
        to="/"
        data-testid="bespoke-ribbon-public-link"
        className={`${muted ? "hover:text-white" : "hover:opacity-70"} hidden sm:inline-flex items-center gap-1 underline-offset-2 hover:underline`}
      >
        DARA · PUBLIC HOME
      </Link>
    </div>
  );
}
